import { getItemMargin } from "widgets/commonComponents/base/multiImagesFrontScroller";
import { MultiImagesScrollPerItem } from "widgets/commonComponents/base/multiImagesScrollPerItem";
import { PromoCarousel } from "../../newYnetTvVerticalDynamic/components/promoCarousel";
import { IFieldDisplayData, VideoSettingsData } from "widgets/commonDataObjects/interfaces";
import { SiteItemData } from "widgets/interfaces";
import { googleScript } from "../../../../widgetsUtils";
import { IMAGE_CIRCLE_IMAGE_SIZE, IMAGE_CIRCLE_ITEM_MARGIN, IMAGE_CIRCLE_SLOT_WIDTH } from "../../../multiImages/imageCircleDisplay";
import { MultiImagesItemFront } from "./frontItem";
import { PromoCarouselLtr } from "../../../newYnetLTRTvVerticalDynamic/components/promoCarouselLtr";

interface MultiImagesFrontProps {
    itemList: SiteItemData[]
    width: number
    fieldsDisplaySettings: IFieldDisplayData
    videoSettings: VideoSettingsData
    imageWidth: number
    imageHeight: number
    onRowDisplay: boolean
    titleColor: string
    isYplusComp?: boolean
    isLTR?: boolean
    isImageOnly?: boolean
    ads_infrastructure_type?: string
    includeAudioPlayer?: boolean
    siteName?: string
    itemColor?: string
    shouldRedirectToArticle?: boolean
    shouldDisplayCategoryIcon?: boolean
    isHiddenHourInYesterday?: boolean
    isImageCircle?: boolean
}

export class MultiImages1280Front extends React.Component<MultiImagesFrontProps> {
    public static siteScriptName = "MultiImages1280Front";

    public render() {
        const { shouldDisplayCategoryIcon, shouldRedirectToArticle, itemColor, imageWidth, itemList, imageHeight, videoSettings, fieldsDisplaySettings, width,
            onRowDisplay, titleColor, isYplusComp, isLTR, isImageOnly, ads_infrastructure_type, includeAudioPlayer, siteName, isHiddenHourInYesterday, isImageCircle } = this.props
        const carouselItemWidth = isImageCircle ? IMAGE_CIRCLE_SLOT_WIDTH : imageWidth
        const shownImageWidth = isImageCircle ? IMAGE_CIRCLE_IMAGE_SIZE : imageWidth
        const shownImageHeight = isImageCircle ? IMAGE_CIRCLE_IMAGE_SIZE : imageHeight
        const itemMargin = isImageCircle ? IMAGE_CIRCLE_ITEM_MARGIN : getItemMargin(width, carouselItemWidth)
        const itemStyle = { marginInlineEnd: itemMargin }

        if (isImageCircle || onRowDisplay) {
            const items = itemList.map((slot, index) => {
                if (slot.isDFP) return (
                    <div id={slot.dfpId} key={index} className={`slotView dfpId ${slot.isCommertial ? "commertialStyle" : ""}`} style={itemStyle}>
                        {ads_infrastructure_type && ads_infrastructure_type === "new" && <script type="text/javascript" dangerouslySetInnerHTML={{ __html: googleScript(slot.dfpId) }}></script>}
                    </div>
                )
                else return (
                    <MultiImagesItemFront
                        key={index}
                        item={slot}
                        isLTR={isLTR}
                        isSmallItem={true}
                        siteName={siteName}
                        margin={itemMargin}
                        itemColor={itemColor}
                        titleColor={titleColor}
                        isYplusComp={isYplusComp}
                        isImageOnly={isImageOnly}
                        onRowDisplay={onRowDisplay}
                        imageWidth={shownImageWidth}
                        isImageCircle={isImageCircle}
                        videoSettings={videoSettings}
                        imageHeight={shownImageHeight}
                        includeAudioPlayer={includeAudioPlayer}
                        fieldsDisplaySettings={fieldsDisplaySettings}
                        shouldRedirectToArticle={shouldRedirectToArticle}
                        isHiddenHourInYesterday={isHiddenHourInYesterday}
                        shouldDisplayCategoryIcon={shouldDisplayCategoryIcon}
                    />
                )
            })

            if (isImageCircle) {
                const Carousel = isLTR ? PromoCarouselLtr : PromoCarousel

                return (
                    <Carousel imageWidth={IMAGE_CIRCLE_SLOT_WIDTH} marginRight={IMAGE_CIRCLE_ITEM_MARGIN} itemListLength={itemList.length}>
                        {items}
                    </Carousel>
                )
            }

            return (
                <MultiImagesScrollPerItem imageWidth={carouselItemWidth} width={width} itemLength={itemList.length} isLTR={isLTR} marginRight={itemMargin}>
                    {items}
                </MultiImagesScrollPerItem>
            )
        }
        else return (
            <div className="slotsContent">
                {itemList.map((slot, index) => {
                    if (slot.isDFP) return (
                        <div id={slot.dfpId} key={index} className={`slotView dfpId ${slot.isCommertial ? "commertialStyle" : ""}`} style={{ margin: "0 10px 24px" }} >
                            {ads_infrastructure_type && ads_infrastructure_type === "new" && <script type="text/javascript" dangerouslySetInnerHTML={{ __html: googleScript(slot.dfpId) }}></script>}
                        </div>
                    )
                    else return (
                        <MultiImagesItemFront
                            key={index}
                            item={slot}
                            isLTR={isLTR}
                            isSmallItem={true}
                            siteName={siteName}
                            margin={itemMargin}
                            itemColor={itemColor}
                            titleColor={titleColor}
                            isImageOnly={isImageOnly}
                            isYplusComp={isYplusComp}
                            onRowDisplay={onRowDisplay}
                            imageWidth={shownImageWidth}
                            isImageCircle={isImageCircle}
                            videoSettings={videoSettings}
                            imageHeight={shownImageHeight}
                            includeAudioPlayer={includeAudioPlayer}
                            fieldsDisplaySettings={fieldsDisplaySettings}
                            shouldRedirectToArticle={shouldRedirectToArticle}
                            isHiddenHourInYesterday={isHiddenHourInYesterday}
                            shouldDisplayCategoryIcon={shouldDisplayCategoryIcon}
                        />
                    )
                })}
            </div>
        )
    }
}